export default __webpack_public_path__ + "static/media/covid-19.2d33af6d.png";